import { isDesktop } from 'helpers/ClientUtils';
import marketplace from 'cfg/marketplace.json';

const { desktopWidthThreshold } = marketplace;
const metaId = 'martyViewportShim';

/*
  This hack is mostly just for tablet screens when we have a
  desktop experience that isn't fully responsive quite yet.
  We should remove this code once we have a truly responsive experience.
  Related issues:
    - https://github01.zappos.net/mweb/marty/issues/2847
    - https://github01.zappos.net/mweb/marty/issues/4414
    - https://github01.zappos.net/mweb/marty/issues/4357
    - https://github01.zappos.net/mweb/marty/issues/4435 (android)
*/

export const mountFixedViewport = () => {
  if (isDesktop(marketplace)) {
    const meta = document.createElement('meta');
    meta.id = metaId;
    meta.name = 'viewport';
    meta.media = `only screen and (min-width: ${desktopWidthThreshold}px)`;
    meta.content = 'width=1024, maximum-scale=1.0, user-scalable=no';
    document.head.appendChild(meta);
    setTimeout(() => {
      meta.content = 'width=1024, maximum-scale=10.0, user-scalable=yes';
    }, 1000);
  }
};

export const unMountFixedViewport = () => {
  // Delete the dupe meta tag that fixes PDP on tablet
  if (isDesktop(marketplace)) {
    const shim = document.getElementById(metaId);
    if (shim) {
      shim.parentNode.removeChild(shim);
    }
  }
};
